/**
 * Fixed bottom-right floating badge: "Powered by Heisenberg"
 * Uses the existing Heisenberg wordmark logo asset.
 */
export default function PoweredByBadge() {
  return (
    <a
      href="https://heisenbergdx.com"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-40 group flex items-center gap-2 px-3 py-2 bg-black/70 hover:bg-black backdrop-blur-md border border-white/10 rounded-full transition-all"
      data-testid="powered-by-badge"
      aria-label="Powered by Heisenberg">
      <span className="font-body text-[9px] uppercase tracking-[0.2em] text-white/60 group-hover:text-white/80 transition-colors">
        powered by
      </span>
      <img src="/assets/logo.png" alt="Heisenberg" className="h-3 w-auto opacity-80 group-hover:opacity-100 transition-opacity" />
    </a>
  );
}
